import axios from 'axios'
import {AuthModel, UserModel} from './_models'

const API_URL = process.env.REACT_APP_API_URL
const AIMS_API = process.env.REACT_APP_BACKEND_BASE_URL || 'http://119.59.114.71:4002'

export const GET_USER_BY_ACCESSTOKEN_URL = `${API_URL}/verify_token`
export const LOGIN_URL = `${AIMS_API}/authentication/login`
export const LOGIN_AD_URL = `${AIMS_API}/authentication/generate-token-from-ad`

export const LOGOUT_URL = `${AIMS_API}/authentication/logout-with-email-pass`
// export const LOGIN_URL = `${API_URL}/login`
export const REGISTER_URL = `${AIMS_API}/register`
export const REQUEST_PASSWORD_URL = `${AIMS_API}/authentication/forget-password`
export const RESET_PASSWORD_URL = `${AIMS_API}/authentication/reset-password`

// Server should return AuthModel
export async function login(email: string, password: string) {
  const ipAddress = await axios.get('https://api.ipify.org?format=json')
  return axios.post<AuthModel>(LOGIN_URL, {
    email,
    password,
    ipAddress: ipAddress.data.ip,
  })
}

export async function loginAD(token: string) {
  const ipAddress = await axios.get('https://api.ipify.org?format=json')
  return axios.post<AuthModel>(LOGIN_AD_URL, {
    token: token,
    ipAddress: ipAddress.data.ip,
  })
}

// Server should return AuthModel
export function register(
  email: string,
  firstname: string,
  lastname: string,
  password: string,
  password_confirmation: string
) {
  return axios.post(REGISTER_URL, {
    email,
    first_name: firstname,
    last_name: lastname,
    password,
    password_confirmation,
  })
}

// Server should return object => { result: boolean } (Is Email in DB)
export function requestPassword(email: string) {
  return axios.post<{result: boolean}>(REQUEST_PASSWORD_URL, {
    email,
  })
}
export function resetPassword(params: any) {
  return axios.post<{result: boolean}>(RESET_PASSWORD_URL, params)
}

export function getUserByToken(token: string) {
  return axios.post<UserModel>(GET_USER_BY_ACCESSTOKEN_URL, {
    api_token: token,
  })
}
